import { ChangeDetectionStrategy, Component, computed, input, model, output } from '@angular/core';
import {
  AgentProfileDto,
  AgentZonesUpdateDto,
  FrenchRegion,
  InterventionZoneDto,
} from '@workspace/data-types';
import { AuraEditWrapperComponent } from '@workspace/ng-aura';
import { AgentZonesDisplayComponent } from '../display/agent-zones-display.component';
import { AgentZonesFormComponent } from '../form/agent-zones-form.component';

@Component({
  selector: 'etxe-agent-zones-edit',
  imports: [AuraEditWrapperComponent, AgentZonesFormComponent, AgentZonesDisplayComponent],
  templateUrl: './agent-zones-edit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentZonesEditComponent {
  readonly initialProfile = input<AgentProfileDto | null>(null);
  readonly initialPrimaryRegion = input<FrenchRegion | undefined>(undefined);
  readonly initialInterventionZones = input<InterventionZoneDto[] | undefined>(undefined);
  readonly isEditing = model<boolean>(false);
  readonly isAllowedToEdit = input<boolean>(true);

  readonly saved = output<AgentZonesUpdateDto>();
  readonly profileSaved = output<AgentProfileDto>();

  readonly currentPrimaryRegion = computed(() => {
    return this.initialPrimaryRegion() ?? this.initialProfile()?.intervention?.primaryRegion;
  });

  readonly currentInterventionZones = computed(() => {
    return this.initialInterventionZones() ?? this.initialProfile()?.intervention?.zones ?? [];
  });

  onSave(dto: AgentZonesUpdateDto | null): void {
    if (!dto) return;
    this.saved.emit(dto);
    const profile = this.initialProfile();
    if (profile) {
      this.profileSaved.emit({
        ...profile,
        intervention: {
          ...profile.intervention,
          primaryRegion: dto.primaryRegion,
          zones: dto.interventionZones,
        },
      });
    }
  }
}
